import React, {SyntheticEvent, useState} from "react";
import {Business} from "./Business";
import SaveIcon from '@mui/icons-material/Save';
import CancelIcon from '@mui/icons-material/Cancel';
import {size, trim} from "lodash"
import {
  Box,
  Button,
  Card,
  CardActions,
  CardContent,
  Checkbox,
  FormControlLabel,
  TextField
} from "@mui/material";
import {LoadingButton} from "@mui/lab";

interface BusinessFormProps {
  business: Business;
  onSave: (business: Business) => void;
  onCancel: () => void;
}

function BusinessForm({
                        business: initialBusiness,
                        onSave,
                        onCancel
                      }: BusinessFormProps) {
  const [business, setBusiness] = useState(initialBusiness);
  const [errors, setErrors] = useState(validate(business));

  function validate(business: Business) {
    let errors: any = {
      ownerName: false,
      businessDescription: false,
      businessName: false,
      shopNumber: false
    };
    errors.ownerName = size(trim(business.ownerName)) < 4;
    errors.shopNumber = size(trim(business.shopNumber)) < 4;
    return errors;
  }

  function isValid() {
    return (
        !errors.ownerName &&
        !errors.shopNumber
    );
  }

  const handleSubmit = (event: SyntheticEvent) => {
    event.preventDefault();
    if (!isValid()) return;
    onSave(business);
  }
  const handleChange = (event: any) => {
    const {type, name, value, checked} = event.target;
    // if input type is checkbox use checked
    // otherwise it's type is text, number etc. so use value
    let updatedValue = type === 'checkbox' ? checked : value;

    //if input type is number convert the updatedValue string to a number
    if (type === 'number') {
      updatedValue = Number(updatedValue);
    }
    const change = {
      [name]: updatedValue,
    };
    let updatedBusiness: Business;

    setBusiness((b) => {
      updatedBusiness = new Business({...b, ...change});
      return updatedBusiness;
    });
    setErrors(() => validate(updatedBusiness));
  }
  return (
      <Card  sx={{
        maxWidth: 330,
        borderRadius: '16px',
        border: '1px solid',
        borderColor: 'primary.main'
      }}>
        <CardContent>
          <Box
              component="form"
              sx={{
                '& .MuiTextField-root': {m: .5, width: '100%'},
              }}
              noValidate
              autoComplete="off"
          >
            <TextField
                required
                error={errors.shopNumber}
                id={business.id + "shopNumber"}
                name={"shopNumber"}
                label="Shop Number"
                sx={{width: '100%'}}
                defaultValue={business.shopNumber}
                onInput={e => handleChange(e)}
                size="small"
                InputLabelProps={{shrink: true}}
                inputProps={{maxLength: 8}}/>
            <TextField
                required
                id={business.id + "ownerName"}
                error={errors.ownerName}
                name={"ownerName"}
                label="Owner Name"
                sx={{width: '100%'}}
                onChange={handleChange}
                size="small"
                defaultValue={business.ownerName ?? ""}
                InputLabelProps={{shrink: true}}
                inputProps={{maxLength: 40}}/>
            <TextField
                id={business.id + "ownerContactNumber"}
                name={"ownerContactNumber"}
                label="Owner mobile"
                sx={{width: '100%'}}
                value={business.ownerContactNumber}
                onChange={handleChange}
                size="small"
                InputLabelProps={{shrink: true}}
                inputProps={{maxLength: 14}}/>
            <TextField
                id={business.id + "ownerWhatsApp"}
                name={"ownerWhatsApp"}
                label="Owner WhatsApp"
                sx={{width: '100%'}}
                value={business.ownerWhatsApp || business.ownerContactNumber}
                onChange={handleChange}
                size="small"
                InputLabelProps={{shrink: true}}
                inputProps={{maxLength: 14}}/>
            <TextField
                id={business.id + "electricityServiceNumber"}
                name={"electricityServiceNumber"}
                label="Service Number for Electricity"
                sx={{width: '100%'}}
                value={business.electricityServiceNumber }
                onChange={handleChange}
                size="small"
                InputLabelProps={{shrink: true}}
                inputProps={{maxLength: 14}}/>
            <TextField
                id={business.id + "businessName"}
                name={"businessName"}
                label="Business Name"
                sx={{width: '100%'}}
                value={business.businessName}
                onChange={handleChange}
                size="small"
                InputLabelProps={{shrink: true}}
                inputProps={{maxLength: 40}}/>
            <TextField
                id={business.id + "businessContactNumber"}
                name={"businessContactNumber"}
                label="Business Contact Number"
                sx={{width: '100%'}}
                value={business.businessContactNumber}
                onChange={handleChange}
                size="small"
                InputLabelProps={{shrink: true}}
                inputProps={{maxLength: 14}}/>
            <TextField
                id={business.id + "businessDescription"}
                name={"businessDescription"}
                sx={{width: '100%'}}
                multiline
                maxRows={4}
                label="Business description"
                defaultValue={business.businessDescription}
                onChange={handleChange}
                size="small"
                InputLabelProps={{shrink: true}}
                inputProps={{maxLength: 150}}/>
            <TextField
                id={business.id + "imageUrl"}
                name={"imageUrl"}
                label="Image URL"
                value={business.imageUrl}
                onChange={handleChange}
                sx={{width: '100%'}}
                size="small"
                InputLabelProps={{shrink: true}}
                inputProps={{maxLength: 400}}/>
            <FormControlLabel id={business.id + "isAvailable"}
                              control={<Checkbox name={"isVacant"} checked={business.isVacant}
                                                 onChange={handleChange}/>}
                              label="Available for rent?"/>
            <CardActions>
              <LoadingButton
                  loading={false}
                  loadingPosition="start"
                  startIcon={<SaveIcon/>}
                  onClick={(e) => handleSubmit(e)}
                  variant="outlined">Save
              </LoadingButton>
              <Button variant="outlined" startIcon={<CancelIcon/>} onClick={onCancel}>
                Cancel
              </Button>
            </CardActions>
          </Box>
        </CardContent>
      </Card>
  );
}

export default BusinessForm;